import React, { useContext, useEffect, useState } from "react";
import "./adminPage.css";
import { Container, Dropdown } from "react-bootstrap";
import { AdminManageContext } from "../AdminListView";
import DataTable from "../../../../components/TableComponent/DataTable";
import SearchData from "../../../../components/SearchComponent/SearchData";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import RefreshIcon from "../../../../assets/images/refresh.svg";
import PluseIcon from "../../../../assets/images/pluse.svg";
import Loader from "../../../../components/Loader/Loader";
import FilterIcon from "../../../../assets/images/icons/filter-icon.svg";
import DropUpIcon from "../../../../assets/images/icons/dropup-icon.svg";
import DropDownIcon from "../../../../assets/images/icons/dropdown-icon.svg";
import BulkRole from "../../../../assets/images/bulkroles.svg";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import RoleSelectPopup from "../../../../components/PopupRoleList/RoleListPopup";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const AdminList = () => {
  const {
    getAdminList,
    adminList,
    onChangeSearch,
    searchData,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    setRoleId,
    setStatus,
    selectedRoleId,
    setSelectedRoleId,
    selectedStatusId,
    setSelectedStatusId,
    adminToAddAdmin,
    adminActivityPage,
    roleId,
    status,
    showDropdown,
    handleSelect,
    handleToggle,
    setRoleSelectData,
    roleSelectData,
    roleListShown,
    roleList,
    handleRoleChange,
    roleCategotyValidate,
    successAlertShow,
    successAlertMessage,
    statusValue,
    bulkRoleAssignApi,
    setSuccessAlertShow,
    selectedUsers,
    setSelectedUsers,
    setCheckBoxDisable,
    checkBoxDisable,
    setRole,
    onClickFilterButton,
    permissionAccess,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    isSuperAdmin,
    handleBulkSubmit,
    handleSelectedAll,
    isRoleExpanded,
    setIsRoleExpanded,
    isStatusExpanded,
    setIsStatusExpanded,
    statuses,
    header,
  } = useContext(AdminManageContext);

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      getAdminList(searchData, roleId, status, pageCount);
    }, 900);
    return () => clearTimeout(timeoutID);
  }, [searchData, roleId, status, pageCount]);

  useEffect(() => {
    roleListShown();
  }, []);
console.log('page count__', pageCount)
  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        <span>{ContentData.adminPage.pageTitle}</span>
      </div>
      {spinnerStatus && <Loader />}

      <Container>
        <div className="pageTittles">{ContentData.adminPage.pageTitle}</div>
        <div className="searchAddSection adminRole">
          <div className="searchSection">
            <SearchData
              placeholder={ContentData.adminPage.searchData}
              value={searchData}
              onChange={onChangeSearch}
              type="text"
            />
          </div>
          <div className="plusRefreshDtat">
            <Dropdown
              autoClose="outside"
              show={showDropdown}
              onToggle={handleToggle}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
                // style={{ height: "23px" }}
              >
                <div className="adminFilterIcon">
                  <img src={FilterIcon} alt="filter" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="admin-dropdown-menu "
                style={{
                  backgroundColor: "#F7F8FA",
                  width: "258px",
                  marginTop: "34px",
                }}
              >
                <Dropdown.Item className="dropdown-filter-clear">
                  <span className="filter-text">
                    {ContentData.adminPage.filter}
                  </span>
                  <span
                    className="clear-all"
                    onClick={() => {
                      handleSelect();
                      setRoleId("");
                      setStatus("");
                      setSelectedRoleId("");
                      setSelectedStatusId("");
                    }}
                  >
                    {ContentData.adminPage.clearAll}
                  </span>
                </Dropdown.Item>
                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isRoleExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsRoleExpanded(!isRoleExpanded);
                  }}
                >
                  Role
                  <img
                    src={isRoleExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>

                {/* Role items */}
                {isRoleExpanded &&
                  roleList.map((role) => (
                    <Dropdown.Item
                      className={`dropdownItem role-item ${
                        selectedRoleId === role._id ? "selected" : ""
                      }`}
                      key={role._id}
                      onClick={(e) => {
                        // handleSelect();
                        e.stopPropagation();
                        const newRoleId =
                          selectedRoleId === role._id ? "" : role._id;
                        console.log("SelectedRoleId", role._id);
                        setSelectedRoleId(newRoleId);
                      }}
                      style={{
                        paddingLeft: "20px",
                        borderBottom: 0,
                      }}
                    >
                      {role.name}
                    </Dropdown.Item>
                  ))}

                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isStatusExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsStatusExpanded(!isStatusExpanded);
                  }}
                  style={{
                    borderBottom: "0",
                  }}
                >
                  Status
                  <img
                    src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>

                {/* Status items */}
                {isStatusExpanded &&
                  statuses.map((status) => (
                    <Dropdown.Item
                      className={`dropdownItem status-item ${
                        selectedStatusId === status.id ? "selected" : ""
                      }`}
                      key={status.id}
                      onClick={(e) => {
                        // handleSelect();
                        e.stopPropagation();
                        const newStatusId =
                          selectedStatusId === status.id ? "" : status.id;

                        setSelectedStatusId(newStatusId);
                      }}
                      style={{
                        paddingLeft: "20px",
                        height: "48px",
                      }}
                    >
                      {status.name}
                    </Dropdown.Item>
                  ))}

                {/* Apply Button */}
                <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                  <ThemeButton
                    value={"Apply"}
                    className={""}
                    onClick={() => {
                      onClickFilterButton(selectedRoleId, selectedStatusId);
                    }}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {isSuperAdmin && (
              <div className="roleRefresh" onClick={() => adminActivityPage()}>
                <img src={RefreshIcon} alt="refresh" />
              </div>
            )}

            <div
              className={`bulkUploadData ${!checkBoxDisable ? "disabled" : ""}`}
              onClick={() => checkBoxDisable && setRoleSelectData(true)}
            >
              <img src={BulkRole} alt="bulk data" />
              <span>{ContentData.adminPage.bulkAdmin}</span>
            </div>

            <div
              className={`addAdmin  addDataAdmin ${
                permissionAccess?.add ? "" : "disabledMainButton"
              } `}
              onClick={() => adminToAddAdmin()}
            >
              <img src={PluseIcon} alt="add" />
              <span>{ContentData.adminPage.addAdmin}</span>
            </div>
          </div>
        </div>
        <div className="basicContainer adminTable roleListTable">
          <DataTable
            tableData={adminList}
            header={header}
            onPageChange={(e) => onPageChange(e)}
            isPagination={true}
            currentPage={pageCount}
            pageCount={totalPage}
          />
        </div>
      </Container>
      <RoleSelectPopup
        labelText={"Role"}
        selectPlaceholder={"Select role"}
        values={roleList}
        selectNum={"_id"}
        label={"name"}
        handleSelectData={handleRoleChange}
        show={roleSelectData}
        roleValidate={roleCategotyValidate}
        handleCancel={() => setRoleSelectData(false)}
        handleSubmit={bulkRoleAssignApi}
      />
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={handleBulkSubmit}
      />
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getAdminList(searchData, roleId, status, pageCount);
          }
        }}
      />
    </div>
  );
};

export default AdminList;
